<template>
  <v-app>
    <!-- BARRA SUPERIOR MODERNA -->
    <v-app-bar app elevation="0" class="glass-app-bar px-4" height="64">
      <v-app-bar-nav-icon @click="drawer = !drawer" color="#37474f" />
      <v-toolbar-title class="d-none d-md-flex align-center">
        <v-avatar size="28" class="mr-2" style="border-radius:6px">
          <v-img src="../assets/icono.png" contain></v-img>
        </v-avatar>
        <span class="font-weight-black" style="color:#37474f;font-size:1rem;letter-spacing:-0.3px">Eduva FE</span>
      </v-toolbar-title>
      
      <v-spacer></v-spacer>

      <v-col cols="12" sm="8" md="5" lg="4" class="px-0">
        <v-select
          v-model="cia"
          :items="companies"
          item-text="ciaNombre"
          item-value="ciaId"
          label="Compañía"
          hide-details
          prepend-inner-icon="mdi-city-variant-outline"
          outlined
          dense
          color="#37474f"
          style="border-radius:8px"
          class="company-selector"
          @change="changeComapny"
        ></v-select>
      </v-col>

      <v-spacer class="d-none d-md-flex"></v-spacer>

      <v-menu offset-y transition="slide-y-transition" bottom left min-width="200">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" text class="px-2 ml-2" style="border-radius:8px">
            <v-avatar size="32" color="#37474f" class="mr-2">
              <span class="white--text text-caption font-weight-bold">{{ user.nombre.charAt(0) }}</span>
            </v-avatar>
            <span class="font-weight-medium d-none d-sm-inline" style="color:#37474f">{{ user.nombre }}</span>
            <v-icon right small color="#37474f">mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list dense class="rounded-lg">
          <v-list-item to="/usuarioseditar">
            <v-list-item-icon><v-icon small>mdi-account-outline</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>Mi Perfil</v-list-item-title></v-list-item-content>
          </v-list-item>
          <v-divider class="my-1"></v-divider>
          <v-list-item to="/" color="error">
            <v-list-item-icon><v-icon small color="error">mdi-logout</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title class="error--text">Cerrar Sesión</v-list-item-title></v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- NAVEGACIÓN LATERAL MODERNA -->
    <v-navigation-drawer 
      app 
      fixed 
      v-model="drawer" 
      class="modern-drawer"
      width="290"
      floating
    >
      <!-- HEADER DEL MENÚ -->
      <div class="drawer-banner pa-5 mb-2">
        <div class="d-flex align-center">
          <div class="drawer-logo-wrap mr-3">
            <v-img src="../assets/icono.png" contain width="32" height="32"></v-img>
          </div>
          <div>
            <div class="text-subtitle-1 font-weight-black" style="color:#37474f;letter-spacing:-0.3px">Eduva FE</div>
            <div class="caption grey--text font-weight-medium" style="opacity:0.6">Soluciones Digitales</div>
          </div>
        </div>
      </div>

      <!-- PERFIL -->
      <div class="px-3 mb-4">
        <v-list-item to="/usuarioseditar" class="profile-card py-2" style="border-radius:10px">
          <v-list-item-avatar color="#37474f" size="36" class="elevation-0 mr-3">
            <span class="white--text font-weight-bold text-body-2">{{ user.nombre.charAt(0).toUpperCase() }}</span>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold text-body-2">{{ user.nombre }}</v-list-item-title>
            <v-list-item-subtitle class="caption" style="color:#546e7a">Ver perfil</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action class="ma-0">
            <v-icon x-small style="color:#546e7a">mdi-chevron-right</v-icon>
          </v-list-item-action>
        </v-list-item>
      </div>

      <v-list nav dense class="px-3">
        <v-list-item-group v-model="selectedItem" color="#37474f">
          <!-- DASHBOARD -->
          <v-list-item :to="inicio.path" :replace="replace" class="nav-item mb-1" style="border-radius:8px">
            <v-list-item-icon class="mr-3">
              <v-icon size="20">mdi-view-dashboard-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium text-body-2">{{ inicio.titulo }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-subheader class="text-uppercase font-weight-bold grey--text text--lighten-1 menu-label px-4 mt-2">Navegación</v-subheader>

          <div v-for="item in items" :key="item.menu">
            <!-- ITEM SIMPLE -->
            <v-list-item 
              v-if="!item.menuOpciones"
              :to="item.path" 
              :replace="replace" 
              class="nav-item mb-1"
              style="border-radius:8px"
            >
              <v-list-item-icon class="mr-3">
                <v-icon size="20">{{ item.icono }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium text-body-2">{{ item.titulo }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- GRUPO -->
            <v-list-group 
              v-else
              :prepend-icon="item.icono" 
              class="nav-group mb-1" 
              no-action
              append-icon="mdi-chevron-down"
              color="#37474f"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium nav-title text-body-2">{{ item.titulo }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item 
                v-for="subItem in item.menuOpciones" 
                :key="subItem.titulo" 
                :to="subItem.path"
                :replace="replace"
                class="nav-subitem mb-1"
                style="border-radius:8px"
              >
                <v-list-item-icon class="mr-2 justify-center">
                  <v-icon size="6" style="color:#546e7a;opacity:0.5">mdi-circle</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-body-2">{{ subItem.titulo }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </div>
        </v-list-item-group>
      </v-list>

      <!-- SECCIÓN INFERIOR: MODO OSCURO -->
      <template v-slot:append>
        <div class="pa-4 drawer-footer">
          <v-card flat class="rounded-xl bg-theme-toggle pa-1">
            <v-list-item dense class="px-2">
              <v-list-item-icon class="mr-2 align-center justify-center">
                <v-icon small style="color:#546e7a">{{ $vuetify.theme.dark ? 'mdi-brightness-4' : 'mdi-brightness-7' }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="caption font-weight-bold" style="color:#546e7a">Apariencia</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action class="ma-0">
                <v-switch 
                  v-model="$vuetify.theme.dark" 
                  color="#37474f" 
                  inset 
                  dense 
                  hide-details
                  class="mt-0 theme-switch"
                ></v-switch>
              </v-list-item-action>
            </v-list-item>
          </v-card>
        </div>
      </template>
    </v-navigation-drawer>

    <!-- CONTENIDO PRINCIPAL -->
    <v-main class="app-content">
      <v-container fluid class="pa-4 pa-md-6">
        <transition name="slide-fade" mode="out-in">
          <router-view :key="$route.path"></router-view>
        </transition>
      </v-container>
    </v-main>

    <!-- DIALOGO DE CONFIRMACIÓN -->
    <v-dialog v-model="dialog" persistent max-width="450">
      <v-card class="rounded-xl pa-2">
        <v-card-title class="text-h6 font-weight-bold">
          <v-icon left color="warning">mdi-alert-circle-outline</v-icon>
          Cambiar de Compañía
        </v-card-title>
        <v-card-text class="pt-2 body-1">
          Si presiona aceptar perderá todos los datos que no hayan sido guardados. ¿Está seguro de continuar?
        </v-card-text>
        <v-card-actions class="pb-4">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text class="rounded-pill font-weight-bold" @click="cancelar()">
            Cancelar
          </v-btn>
          <v-btn color="primary" depressed class="rounded-pill px-6 font-weight-bold" @click="aceptar()">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Snackbar v-bind:text="snackText" v-bind:snackbar.sync="snackValue" />
  </v-app>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import axios from "axios";
import Snackbar from "../components/shared/Snackbar.vue";

export default {
  components: {
    Snackbar,
  },
  data() {
    return {
      drawer: true,
      replace: true,
      selectedItem: "",
      cia: "",
      ciaOld: "",
      items: [],
      companies: [],
      dialog: false,
      inicio: {
        titulo: "Dashboard",
        icono: "mdi-view-dashboard-outline",
        path: "/dashboard",
      },
      snackText: "",
      snackValue: false,
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav);
    this.getModeloMenu();
    this.getCompanies();
    this.cia = this.user.ciaPorDefecto;
    this.ciaOld = this.user.ciaPorDefecto;
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.preventNav);
  },
  methods: {
    ...mapMutations(["setStrCia"]),
    changeComapny() {
      this.dialog = true;
    },
    aceptar() {
      this.setStrCia(this.cia);
      this.ciaOld = this.cia;
      this.dialog = false;
      this.$router.replace({ name: "Dashboard" });
    },
    cancelar() {
      this.cia = this.ciaOld;
      this.dialog = false;
    },
    getCompanies() {
      let me = this;
      me.setStrCia(this.user.ciaPorDefecto);
      axios
        .get("api/Usuarios/getCiasPorUsuario?usuarioId=" + this.user.id)
        .then(function (response) {
          me.companies = response.data;
          me.cia = me.user.ciaPorDefecto;
          me.ciaOld = me.user.ciaPorDefecto;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getModeloMenu() {
      let me = this;
      me.setStrCia(this.user.ciaPorDefecto);
      axios
        .get("api/Usuarios/getModeloMenu?usuarioId=" + this.user.id)
        .then(function (response) {
          me.items = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    preventNav() {
      // event.preventDefault(); // Comentar o manejar según necesidad real
    },
  },
};
</script>

<style scoped>
.modern-drawer {
  border-right: none !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 2px 0 16px rgba(0,0,0,0.06) !important;
}

.theme--light.modern-drawer {
  background: #f8fafc !important;
}

.theme--dark.modern-drawer {
  background: #1a2327 !important;
}

/* HEADER DEL MENÚ */
.drawer-banner {
  background: #ffffff;
  border-bottom: 1px solid rgba(55,71,79,0.08);
}
.theme--dark .drawer-banner {
  background: #1a2327;
  border-bottom: 1px solid rgba(255,255,255,0.05);
}

.drawer-logo-wrap {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: rgba(55,71,79,0.08);
  display: flex;
  align-items: center;
  justify-content: center;
}

.line-height-1 {
  line-height: 1.2;
}

/* ESTILOS DE ITEMS DE NAVEGACIÓN */
.nav-item {
  transition: background 0.15s ease, transform 0.15s ease;
  margin-top: 2px;
  border-radius: 8px !important;
}

.nav-item:hover {
  background-color: rgba(55, 71, 79, 0.07) !important;
}

.nav-item.v-list-item--active {
  background: rgba(55, 71, 79, 0.12) !important;
  box-shadow: none !important;
}

.nav-item.v-list-item--active::after {
  content: "";
  position: absolute;
  left: 0;
  top: 20%;
  height: 60%;
  width: 3px;
  background: #37474f;
  border-radius: 0 4px 4px 0;
}

.menu-label {
  font-size: 0.7rem;
  letter-spacing: 1.5px;
  height: 32px;
}

.nav-title {
  white-space: normal !important;
  line-height: 1.2 !important;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* GRUPOS Y SUBITEMS */
.nav-group >>> .v-list-group__header {
  padding-left: 12px !important;
  padding-right: 12px !important;
  border-radius: 16px;
}

.nav-group >>> .v-list-group__header__prepend-icon {
  margin-right: 16px !important;
}

.nav-group >>> .v-list-group__items {
  padding-left: 24px !important;
}

.nav-subitem {
  min-height: 34px !important;
  border-radius: 8px !important;
  padding-left: 6px !important;
}

.nav-subitem:hover {
  background-color: rgba(55, 71, 79, 0.05) !important;
}

.nav-subitem.v-list-item--active {
  background-color: rgba(55,71,79,0.1) !important;
}

/* FOOTER Y SWITCH */
.drawer-footer {
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.theme--dark .drawer-footer {
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.bg-theme-toggle {
  background-color: #f1f5f9 !important;
}

.theme--dark .bg-theme-toggle {
  background-color: #1e293b !important;
}

.theme-switch >>> .v-input--selection-controls__ripple {
  display: none;
}

/* GENERAL */
.glass-app-bar {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important;
}

.theme--dark .glass-app-bar {
  background: rgba(15, 23, 42, 0.8) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;
}

.app-content {
  transition: opacity 0.3s ease;
}

.profile-card {
  background: rgba(55, 71, 79, 0.05) !important;
  border: 1px solid rgba(55, 71, 79, 0.1) !important;
  transition: background 0.2s ease;
}

.theme--dark .profile-card {
  background: rgba(255,255,255,0.05) !important;
  border: 1px solid rgba(255,255,255,0.08) !important;
}

.profile-card:hover {
  background: rgba(55, 71, 79, 0.1) !important;
}

.company-selector >>> .v-input__control {
  min-height: 40px !important;
}

/* CUSTOM SCROLLBAR FOR PREMIUM LOOK */
.modern-drawer >>> .v-navigation-drawer__content::-webkit-scrollbar {
  width: 4px;
}

.modern-drawer >>> .v-navigation-drawer__content::-webkit-scrollbar-track {
  background: transparent;
}

.modern-drawer >>> .v-navigation-drawer__content::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

.theme--dark .modern-drawer >>> .v-navigation-drawer__content::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>